import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import I18n from 'app/i18n';
import FreespinInterface from 'app/interfaces/Freespinsinterface';
import {UserBonusesStore} from 'app/store/UserBonusesStore';
import {getActivateClickHandler, getCancelClickHandler, getFreeSpinsQuantityImage} from 'app/helpers/free_spin_helpers.tsx';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import FreespinsTimer from 'app/components/my_profile/freespins/FreespinsTimer';
import {size380x380} from 'app/utils/CasinoGameImages';

interface PropsInterface {
    spin: FreespinInterface;
    userBonusesStore?: UserBonusesStore;
}

@inject('userBonusesStore')
@observer
export default class FreespinsContentItem extends Component<PropsInterface> {
    hideExpiredFreespin = (): void => {
        this.props.userBonusesStore?.removeFreeSpinAfterCancel(this.props.spin.id);
    };

    render(): React.ReactNode {
        const {spin, userBonusesStore} = this.props;
        const {quantity, provider, game, game_id, time_left, identifier} = spin;
        const freeSpinsQuantityImage = getFreeSpinsQuantityImage(quantity);
        const gameImage = size380x380(
            provider ?? '',
            identifier ?? '',
            spin.released_at,
            spin.in_out,
            spin.image_url
        );

        return (
            <div className="freespins-item">
                <div className="freespins-item__image">
                    <img src={gameImage} alt={game} />
                </div>
                <div className="freespins-item__content">
                    <img className="freespins-item__quantity" src={freeSpinsQuantityImage} alt={`${quantity} free spins`} />
                    <div className="freespins-item__about">
                        <span className="freespins-item__game" title={game}>
                            {game}
                        </span>
                        <span className="freespins-item__provider" title={provider}>
                            {provider}
                        </span>
                    </div>
                    <div className="freespins-item__footer">
                        <FreespinsTimer timeLeft={time_left} hideExpiredFreespin={this.hideExpiredFreespin}/>
                        <button
                            className="button-adaptive freespins-item__button"
                            onClick={getActivateClickHandler(game_id)}
                        >
                            {I18n.t('go_game')}
                        </button>
                    </div>
                </div>
                <button
                    className="freespins-item__cancel"
                    onClick={getCancelClickHandler(spin, userBonusesStore!)}
                >
                    <SpriteIcon name="#svg-close" size={{height: 12, width: 12}} className="svg-default"/>
                </button>
            </div>
        );
    }
}
